const zh = {
  login: {
    login: 'Login'
  },
  // layout
  commons: {
    xiaoai: 'Ai.',
    admin: 'Admin',
    editor: 'Editor',
    quit: 'Sign Out',
    hi: 'Hi',
    index: 'Dashboard',
    userManage: 'Users',
    share: 'Share',
    infoManage: 'Infos',
    infoShow: 'InfoShow',
    infoShow1: 'InfoShow1',
    infoShow2: 'InfoShow2',
    infoShow3: 'InfoShow3',
    infoShow4: 'InfoShow4',
    infoShow5: 'InfoShow5',
    infoModify: 'InfoModify',
    infoModify1: 'InfoModify1',
    infoModify2: 'InfoModify2',
    infoModify3: 'InfoModify3',
    fundManage: 'Money',
    fundList: 'MoneyList',
    chinaTabsList: 'AreaList',
    fundData: 'FundData',
    fundPosition: 'FundPosition',
    typePosition: 'TypePosition',
    incomePayPosition: 'IncomePayPosition',
    permission: 'Permission',
    pagePer: 'PagePermission',
    directivePer: 'DirectivePermission',
    errorPage: 'ErrorPage',
    page401: '401',
    page404: '404',
    wechatNumber: 'wechat'
  },
  index: {
    yearLoss: 'Year Loss',
    yearProfit: 'Year Profit',
    potentialInvestor: 'Potential Investor',
    intentionInvestor: 'Intention Investor',
    waitExamineInvestor: 'Wait Examine Investor',
    examiningInvestor: 'Examining Investor',
    tenMillion: 'Ten Million',
    person: 'P'
  }
}

export default zh
